export const listTef = [
  { textCredential: 'Credibanco Smartpos', valueCredential: '1' },
  { textCredential: 'Credibanco Smartpos Sin ID', valueCredential: '3' },
  { textCredential: 'Credibanco Aplicaciones', valueCredential: '2' },
  { textCredential: 'Credibanco Tramas', valueCredential: '4' },
  { textCredential: 'Redeban Aplicaciones', valueCredential: '6' },
]
